var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index"}},[_c('el-container',[_c('el-scrollbar',{class:_vm.isCollapse ? 'menu_hide rightSide' : 'rightSide'},[_c('el-main',{staticStyle:{"padding":"0"}},[_c('nav-bar',{staticStyle:{"padding-left":"20px"}}),[_c('iframe',{attrs:{"src":_vm.url,"id":"iframe","scrolling":"no","frameborder":"0"}})]],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }